import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getProducerAttachments } from '../../shared/services/get-attachments.service';
import { AttachmentFile } from '../../shared/models/attachment-file.model';
import * as exifr from 'exifr';
import styles from './ProducerCard.module.scss';

const isFirefox = () => {
    return typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
};

export default function ProducerCard(props: any) {
    const { t } = useTranslation("translation");
    const navigate = useNavigate();
    const [imageId, setImageId] = useState<string>();
    const [imageFailed, setImageFailed] = useState(false);
    const [rotation, setRotation] = useState<number>(0);

    const hasImage = !!imageId && !imageFailed;
    const imageUrl = hasImage ? `${process.env.REACT_APP_BASE_URL}Images/file/${imageId}` : undefined;

    const handleProductClick = () => {
        navigate("/producer-details-view/" + props.producer?.id);
    };

    useEffect(() => {
        setImageFailed(false);
        setRotation(0);
        setImageId(undefined);
        if (props.producer?.id) {
            getProducerAttachments(props.producer.id).then((response) => {
                const image = response?.data?.find((attachment: AttachmentFile) => attachment.type === 'IMAGE');
                setImageId(image?.id);
            }).catch(() => {
                setImageId(undefined);
            });
        }
    }, [props.producer]);

    useEffect(() => {
        if (isFirefox() && imageUrl) {
            exifr.parse(imageUrl).then((exifData) => {
                const orientation = exifData?.Orientation;
                switch (orientation) {
                    case "Rotate 90 CW":
                        setRotation(90);
                        break;
                    case "Rotate 180 CW":
                        setRotation(180);
                        break;
                    case "Rotate 270 CW":
                        setRotation(270);
                        break;
                    default:
                        setRotation(0);
                        break;
                }
            }).catch((error) => {
                console.error("Error reading EXIF data:", error);
                setRotation(0);
            });
        }
    }, [props.producer, imageUrl]);

    return (
        <div className={styles.card_container}>
            <div className={styles.image_icons_container}>
                {hasImage ? (
                    <Link to={`/producer-details-view/${props.producer?.id}`}>
                    <img
                        src={imageUrl}
                        alt={props.producer.imageName}
                        style={{
                            transform: `rotate(${rotation}deg)`,
                        }}
                        className={styles.producer_image}
                        onError={() => setImageFailed(true)}
                    />
                </Link>
                ) : (
                <Link to={`/producer-details-view/${props.producer?.id}`} className={styles.image_placeholder} aria-label={`View ${props.producer?.name} details`}>
                    <span className="sr-only">View producer details</span>
                </Link>
                )}
            </div>
            <div className={styles.producer_name_container}>
            <Link to={`/producer-details-view/${props.producer?.id}`}><h6>{props.producer?.name}</h6></Link>
            </div>
            <Link to={`/producer-details-view/${props.producer?.id}`} className={styles.more_button}>
                {t("producer.card.more")}
            </Link>
        </div>
    );
}
